document.addEventListener("alpine:init", () => {
  Alpine.data("filesController", (blog_media_url, blog_id, onPostPage) => ({
    photoPicker: null,
    fileOverlayOpen: false,
    blog_id: "",
    observers: [],
    onPostPage: false,
    tabNames: ["swish", "unsplash", "pixabay", "pexels"],
    tab: "swish",
    tabs: {
      swish: {
        query: "",
        files: [],
        cursor: "",
        page: 0,
        has_more: true,
      },
      unsplash: {
        query: "",
        files: [],
        cursor: "",
        page: 0,
        has_more: true,
      },
      pixabay: {
        query: "",
        files: [],
        cursor: "",
        page: 0,
        has_more: true,
      },
      pexels: {
        query: "",
        files: [],
        cursor: "",
        page: 0,
        has_more: true,
      },
    },

    setup($nextTick) {
      if (!blog_id) blog_id = "";
      this.blog_id = blog_id;

      this.onPostPage = !!onPostPage;

      // Set up the media picker
      if (!this.photoPicker) {
        this.photoPicker = window.setupUppy(
          this.$dispatch,
          "uppy",
          "/" + blog_id + "/media",
        );
      }

      // Trigger observer whenever the loading svg is 50% shown
      let options = { threshold: 0.5 };

      // Do in next tick so that the svg have been added to the DOM
      $nextTick(
        function() {
          this.tabNames.forEach(
            function(name) {
              if (!this.observers.name) {
                // Load more when the loading svg isIntersecting
                new IntersectionObserver(
                  function(entries) {
                    entries.forEach(
                      function(entry) {
                        if (entry.isIntersecting && this.tabs[name].has_more) {
                          this.search();
                        }
                      }.bind(this),
                    );
                  }.bind(this),
                  options,
                ).observe(document.querySelector("#load-more-" + name));

                this.observers[name] = true; // prevents adding multipe observers
              }
            }.bind(this),
          );
        }.bind(this),
      );
    },

    focusOnSearchbox() {
      document.getElementById("search").focus();
    },

    switchTab(to) {
      this.tab = to;
      this.search();
      this.focusOnSearchbox();
    },

    openUploadModal() {
      this.photoPicker.getPlugin("Dashboard").openModal();
    },

    openFileOverlay() {
      document.getElementById("file-overlay").classList.remove("hidden");
      document.getElementById("file-overlay").classList.add("z-50");
      this.fileOverlayOpen = true;
      this.focusOnSearchbox();
    },

    closeFileOverlay() {
      this.fileOverlayOpen = false;
      window.setTimeout(() => {
        document.getElementById("file-overlay").classList.add("hidden");
        document.getElementById("file-overlay").classList.remove("z-50");
      }, 700);
    },

    fileUploaded(file) {
      let galleryFile = {
        id: file.id,
        name: file.name,
        title: file.title,
        insert_url: encodeURIComponent(file.name),
        display_url: blog_media_url.replace("media-slug", file.name),
        caption: {
          markdown: "",
          html: "",
        },
        can_delete: true,
        track_use: false,
      };

      this.tabs.swish.files.unshift(galleryFile);
      this.$dispatch("notify", {
        msg: file.name + " uploaded",
        type: "success",
      });

      this.insertFile(galleryFile);
    },

    insertFile(file) {
      file.source = this.tab;

      if (file.track_use) {
        this.trackFileUse(file);
      }

      if (this.onPostPage) {
        this.$dispatch("insert-post-file", file);
        return;
      }

      $this.dispatch("insert-file", file);
    },

    search() {
      const $dispatch = this.dispatch;
      const query = document.getElementById("search").value;
      const tab = this.tab;

      let tabDetails = this.tabs[tab];

      const has_more = tabDetails.has_more;
      const newSearch = query !== tabDetails.query;

      if (!newSearch && !has_more) return;

      const params = new URLSearchParams({
        source: tab,
        query: query || "",
      });

      if (!newSearch) {
        params.append("after", tabDetails.cursor);
        params.append("page", tabDetails.page + 1);
      }

      const filesURL =
        "/" + this.blog_id + "/media/search?" + params.toString();

      let respData = [];

      fetch(filesURL, {
        credentials: "include",
        method: "GET",
      })
        .then(window.status)
        .then(window.json)
        .then(function(data) {
          data.success?.forEach(function(message) {
            $dispatch("notify", { msg: message, type: "success" });
          });
          data.error?.forEach(function(message) {
            $dispatch("notify", { msg: message, type: "error" });
          });
          if (data.redirect_to !== "") {
            window.location = data.redirect_to;
          }

          respData = data.data;
        })
        .catch(function(err) {
          console.log("Fetch Error :-S", err);
          $dispatch("notify", { msg: "Error loading files", type: "error" });
        })
        .finally(
          function() {
            tabDetails.query = query;
            tabDetails.cursor = respData.end_cursor;
            tabDetails.page = respData.page_no;
            tabDetails.has_more = respData.has_next_page;

            if (newSearch) {
              tabDetails.files = [];
            }
            if (respData.results) {
              tabDetails.files = tabDetails.files.concat(respData.results);
            }

            this.tabs[tab] = tabDetails;
          }.bind(this),
        );
    },

    deleteFile(file) {
      const $dispatch = this.$dispatch;

      if (!window.confirm('Permanently delete "' + file.title + '" ?')) return;
      // Send delete AJAX call
      let deleteURL = "/" + this.blog_id + "/media/" + file.id;
      fetch(deleteURL, {
        credentials: "include",
        method: "DELETE",
      })
        .then(window.status)
        .then(window.json)
        .then(function(data) {
          data.success?.forEach(function(message) {
            $dispatch("notify", { msg: message, type: "success" });
          });
          data.error?.forEach(function(message) {
            $dispatch("notify", { msg: message, type: "error" });
          });
          if (data.redirect_to !== "") {
            window.location = data.redirect_to;
          }

          // Use this instead of adding to the array
          // When a new element is added to the array, every picture is redownloaded
          // So just remove it from the dom
          $dispatch("file-deleted", file);
          file.hidden = true;
        })
        .catch(function(err) {
          console.log("Fetch Error :-S", err);
          $dispatch("notify", { msg: "Error deleting file", type: "error" });
        });
    },

    trackFileUse(file) {
      let form = new FormData();
      form.append("source", file.source);
      form.append("metadata", JSON.stringify(file.metadata));

      fetch("/" + this.blog_id + "/external-image-used/", {
        credentials: "include",
        method: "POST",
        body: form,
      });
    },
  }));
});
